import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../style/languageSelector.css';

const englishLanguage = { code: 'en', name: 'English', flag: 'GB' };

const languages = [
  englishLanguage,
  { code: 'ru', name: 'Русский', flag: 'RU' },
  { code: 'it', name: 'Italiano', flag: 'IT' },
  { code: 'ro', name: 'Română', flag: 'RO' },
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    languages.find((lang) => i18n.language.includes(lang.code)) || englishLanguage,
  );

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const selectLanguage = (lang) => {
    setSelectedLanguage(lang);
    i18n.changeLanguage(lang.code).then(() => {
      localStorage.setItem('i18nextLng', lang.code);
    });
    setIsOpen(false);
  };

  return (
    <div className="language-dropdown">
      <button className="dropdown-toggle" onClick={toggleDropdown}>
        <img
          alt={selectedLanguage.code}
          src={`img/flags/flag-${selectedLanguage.code}.png`}
          className="flag"
        />
        <span className="language-name">{selectedLanguage.name}</span>
        <span className={`arrow ${isOpen ? 'up' : 'down'}`}></span>
      </button>
      {isOpen && (
        <ul className="dropdown-menu">
          {languages.map((lang) => (
            <li key={lang.code} className="dropdown-item" onClick={() => selectLanguage(lang)}>
              <img alt={lang.code} src={`img/flags/flag-${lang.code}.png`} className="flag" />
              <span className="language-name">{lang.name}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSelector;
